import React from 'react';

import CardItem from '../../../../../components/CardItem';
import formatterBR, { formatter } from "../../../../../functions/formatCurrency";
import bankAccountServices from '../../../../../services/admFin/bankAccountServices';

export default function BankAccountTransferCardItem(props) {
    let formatterCurrency = props.currency && props.currency !== "BRL" ? formatter(props.currency) : formatterBR;

    return (
        <CardItem
            onClick={props.onClick}
        >
            {
                props.conta_origem ?
                <>
                    <h5><b>Conta Bancária Origem:</b> </h5>
                    <p>{bankAccountServices.formatBankAccount(props.conta_origem)}</p>
                </>
                :
                null
            }
            {
                props.conta_destino ?
                <>
                    <h5><b>Conta Bancária Destino:</b> </h5>
                    <p>{bankAccountServices.formatBankAccount(props.conta_destino)}</p>
                </>
                :
                null
            }
            <h6><b>{props.descricao}</b></h6>
            
            <p>Valor transferido: {formatterCurrency.format(props.valor)}</p>
            <p>Data: {props.data ? props.data.split('-').reverse().join('/') : ""}</p>
        </CardItem>
    )
}